<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<nav [class]="['tabs', vertical() ? 'vertical' : 'horizontal']">
    @for (tab of tabsList(); track tab) {
        @if (!tab.hidden) {
            <a
                    (click)="tab.invalid = false; activeTab.set(tab)"
                    class="tab"
                    [ngClass]="{
                    'active': tab === activeTab(),
                    'invalid': tab !== activeTab() && tab.invalid
                }"
            >
                {{ tab.title() }}
                @if (tab.closable) {
                    <button windeClose (click)="tabClosed.emit(tab)">
                        <sui-svg-icon icon="cross"/>
                    </button>
                }
            </a>
        }
    }
</nav>
